import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { map, startWith, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { id } from 'date-fns/locale';
import { CandidateService } from 'src/app/services/candidate-service.service';
@Injectable({
  providedIn: 'root'
})
export class CandidateDetailsService {

  opOpen$: Observable<boolean> = of(false);
  constructor(private popoverService: PopoverService, private router: Router, private candidateServices: CandidateService) { }



  async processCandidateOperation(route: any, origin: any) {
    this.router.navigate([route])
  }

  public deatilsCandidateList() {
    let examNo = this.candidateServices.selectedCandidates?.[0]?.examNo;
    return [
      {
        icon: 'mat:contacts',
        label: 'View Candidate',
        route: 'candidates/view',
        id: 'view_passport_photo'
      },
      {
        icon: 'mat:lock',
        label: 'Seb Lockouts',
        route: `candidates/${examNo}/seb-lockouts`,
        id: 'candiddates_seb_lockouts'
      },
      {
        icon: 'mat:assignment',
        label: 'View Schedule Details',
        route: {
          path: `/exams/0/schedules`,
          queryParams: { examNo: examNo }
        },
        id: 'examinations_examination_schedules'
      },
    ];
  }
}
